import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHolidayListContext } from "context/HolidayListContext";
import Breadcrumb from "../../../components/layout/Breadcrumb";
import { months, daysOfWeek } from "constant";
import { Button, Modal, Form, Row, Col } from "react-bootstrap";
import { fetchAllHoliday, updateHoliday,createHoliday, publishHoliday,deleteHoliday, HRViewHoliday, getHolidayById} from "../../../redux/slice/getAllHolidaySlice";
import { useHasPermission } from "../../../hooks/useHasPermission";
export default function Holidays() {
  const dispatch = useDispatch();
  const canManageHoliday = useHasPermission("Holiday-manage");
  const canManagePublishHoliday = useHasPermission("Holiday-Publish-manage");
  const [year, setYear] = useState(new Date().getFullYear());
  const holidays = useHolidayListContext();
  const [formMode, setFormMode] = useState("add");
  const [formData, setFormData] = useState({});
  const [holidayToDelete, setHolidayToDelete] = useState(null);
  const [expandedHoliday, setExpandedHoliday] = useState(null);
  const [holidayYear, setHolidayYear] = useState(new Date().getFullYear());

  const toggleHoliday = (id) => {
    setExpandedHoliday((prevId) => (prevId === id ? null : id));
  };

  const AllHoliday = useSelector((state) => state.allHolidayData.allHolidays.holidayResponseDtos);
  const HolidayStatus = useSelector((state) => state.allHolidayData.allHolidays.status);

  //console.log("fetchAllHoliday", fetchAllHoliday);
  useEffect(() => {
   //console.log("FETCH API CALLED");
  dispatch(fetchAllHoliday(holidayYear));
}, [holidayYear, dispatch]);

  const handleAddHolidaySubmit = async () => {
    const holidayData = {
      holidayName: title,
      holidayDescription: description,
      holidayDate: toDate,
      dayOfHoliday: "MONDAY",
      holidayType: holidayType,
      isMandatory: true,
    };

    try {
      const result = await dispatch(createHoliday(holidayData));
      if (createHoliday.fulfilled.match(result)) {
        dispatch(fetchAllHoliday(holidayYear));
        setShowEditModal(false);
        resetForm();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const selectedHoliday = useSelector(
  (state) => state.allHolidayData.selectedHoliday
);
useEffect(() => {
  if (selectedHoliday) {
    setTitle(selectedHoliday.holidayName || "");
    setToDate(selectedHoliday.holidayDate || "");
    setHolidayType(selectedHoliday.holidayType || "");
    setDescription(selectedHoliday.holidayDescription || "");
    setEditHolidayId(selectedHoliday.id);
    setIsEditMode(true);
    setShowEditModal(true);
  }
}, [selectedHoliday]);

  const handleUpdateHoliday = async () => {
  const holidayData = {
      holidayName: title,
      holidayDescription: description,
      holidayDate: toDate,
      dayOfHoliday: "MONDAY",
      holidayType: holidayType,
      isMandatory: true,
    };

    try {
      const result = await dispatch(
        updateHoliday({  id: editHolidayId, holidayData,   }),
      );

      if (updateHoliday.fulfilled.match(result)) {
        setShowEditModal(false);
        resetForm();
      }
    } catch (error) {
      console.log(error);
    }};

  const resetForm = () => {
    setTitle("");
    setToDate("");
    setHolidayType("");
    setDescription("");
    setEditHolidayId(null);
    setIsEditMode(false);
  };

  const handlePublishHoliday = async () => {
    try {
      const resultAction = await dispatch(publishHoliday(year));
      if (publishHoliday.fulfilled.match(resultAction)) {
        console.log("Holiday Published Successfully");
      } else {
        console.log(resultAction.payload);
      }
    } catch (error) {
      console.log("Publish API Error", error);
    }
  };

  const handleDeleteConfirm = async () => {
    try {
      const resultAction = await dispatch(deleteHoliday(holidayToDelete.id));
      if (deleteHoliday.fulfilled.match(resultAction)) {
        setShowDeleteModal(false);
      } else {
        console.log(resultAction.payload);
      }
    } catch (error) {
      console.log("Delete API Error", error);
    }
  };

  const handleAddClick = () => {
    setFormMode("add");
    setFormData({ name: "", date: "", type: "" });
    setShowFormModal(true);
  };

  const handleEditClick = (holiday) => {
    setIsEditMode(true);
    setEditHolidayId(holiday.id);
    setTitle(holiday.holidayName || "");
    setToDate(holiday.holidayDate || "");
    setHolidayType(holiday.holidayType || "");
    setDescription(holiday.holidayDescription || "");
    setShowEditModal(true);
  };

  const handleDeleteClick = (holiday) => {
    setHolidayToDelete(holiday);
    setShowDeleteModal(true);
  };
  const handleFormSubmit = () => {
    if (formMode === "add") {
      // console.log("Adding new holiday:", formData);
    } else {
      // console.log("Updating holiday:", formData);
    }
    setShowFormModal(false);
  };

  const handleImportSubmit = (file) => {
    // console.log("Importing file:", file.name);
    setShowImportModal(false);
  };


  const [showEditModal, setShowEditModal] = useState(false);
  const [title, setTitle] = useState("");
  const [fromDate, setFromDate] = useState("");
  const [toDate, setToDate] = useState("");
  const [holidayType, setHolidayType] = useState("");
  const [description, setDescription] = useState("");
  const [editHolidayId, setEditHolidayId] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const generateMonthDays = (monthIndex) => {
    const firstDay = new Date(year, monthIndex, 1).getDay();
    const totalDays = new Date(year, monthIndex + 1, 0).getDate();
    const today = new Date();

    let days = [];
    for (let i = 0; i < firstDay; i++) {
      days.push(<div key={`empty-${monthIndex}-${i}`} className="empty"></div>);
    }

    for (let day = 1; day <= totalDays; day++) {
      const isToday =
        today.getFullYear() === year &&
        today.getMonth() === monthIndex &&
        today.getDate() === day;
      const holidayData = AllHoliday?.find((holiday) => {
      const holidayDate = new Date(holiday.holidayDate);
      return (
        holidayDate.getFullYear() === year &&
        holidayDate.getMonth() === monthIndex &&
        holidayDate.getDate() === day
       );
});
       const isHoliday = holidayData;
       const formattedDate = `${year}-${String(monthIndex + 1).padStart(2, "0")}-${String(day).padStart(2, "0")}`;

      days.push(
        <div
          key={`day-${monthIndex}-${day}`}
          className={`day ${isToday ? "today" : ""} ${isHoliday ? "holiday" : ""}`}
>
          {" "} {day}{" "}
        </div>,
      );
    }
    return days;
  };

  return (
    <div className="calendar-fluid calendar-box">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <Breadcrumb />
      </div>
      <div className="holidays-section">
          <div className="d-flex justify-content-between align-items-center">
            <div
                 style={{ cursor: "pointer" }}
                 onClick={() => {
                 setHolidayYear((prev) => prev - 1);
                 setYear(year-1);
                }} >
        <Button
          type="button"
          className="primary-btn"
        >
        <i className="fas fa-chevron-left"></i> {year-1}
        </Button>
                   
            </div>
              <div>
                 <h5>Holidays List - {holidayYear}</h5>
            </div>
                  <div
                   style={{ cursor: "pointer" }}
                   onClick={() => {
                  setHolidayYear((prev) => prev + 1);
                  setYear(year + 1);
             }} >
              <Button
          type="button"
          className="primary-btn ml-4"
        >
          {year+1} <i className="fas fa-chevron-right"></i>
        </Button>
                     
                </div>
           </div>
        <div className="holidays-scroll-area">
          <div className="holidays-grid">
            {HolidayStatus==="PUBLISHED"&&(AllHoliday?.map((holiday) => {
              const uniqueId = `holiday-${holiday.id}`;

              const menuActions = [
                {
                  label: "Edit",
                  icon: require("assets/img/edit-icon.png"),
                  permission: true,
                  show: true,
                  onClick: () => handleEditClick(holiday),
                },
                {
                  label: "Delete",
                  icon: require("assets/img/delete.png"),
                  permission: true,
                  show: true,
                  onClick: () => handleDeleteClick(holiday),
                },
              ];

              return (
                <div
                  key={uniqueId}
                  className="holiday-item"
                  style={{
                    border: "1px solid #e0e0e0",  borderLeft: "4px solid #6f42c1",borderRadius: "4px",backgroundColor: "#fff", overflow: "hidden",display: "flex",  flexDirection: "column", alignSelf: "start",  }}
                >
                  <div
                    className="holiday-header d-flex justify-content-between align-items-center p-0"
                    onClick={() => toggleHoliday(uniqueId)}
                    style={{ cursor: "pointer" }}
                  >
                    <span
                      style={{fontWeight: "500",  color: "#333", fontSize: "14px",  }}
                    >
                      {holiday.holidayName}
                    </span>

                    <div className="d-flex align-items-center">
                      <span
                        className="me-2 text-muted"
                        style={{ fontSize: "14px" }}
                      >
                        {holiday.holidayDate}
                      </span>
                      <i
                        className={`ms-2 fas ${expandedHoliday === uniqueId ? "fa-chevron-up" : "fa-chevron-down"}`}
                        style={{ fontSize: "12px", color: "#ccc" }}
                      ></i>
                    </div>
                  </div>

                  {expandedHoliday === uniqueId && (
                    <div
                      style={{padding: "12px 16px",borderTop: "1px solid #f0f0f0",backgroundColor: "#fafafa",}}>
                      <p  style={{  margin: "0",  fontSize: "13px", color: "#6c757d", lineHeight: "1.5", }}  >
                        {holiday.holidayDescription ||
                          "No description available for this holiday."}
                      </p>
                    </div>
                  )}
                </div>
              );
            }))}
          </div>
        </div>
      </div>
      <div className="calendar-container mt-4">
        <h3 className="year-heading">{year}</h3>
        <div className="year-grid">
          {months.map((month, index) => (
            <div key={month} className="month">
              <h5>{month}</h5>
              <div className="weekdays">
                {daysOfWeek.map((day) => (
                  <div key={day} className="weekday">
                    {day}
                  </div>
                ))}
              </div>
              <div className="days-grid">{generateMonthDays(index)}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}